import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import UsersPage from 'components/pages/Users';

import pageTitles from 'utils/pageTitles';
import { setTitle, setActiveMenuItem } from 'containers/store';

import {
  onAddClick, onDelete, onEdit, onSearchSubmit, onView, loadPageData,
  onChangeSort, onChangePage, onChangeRowsPerPage,
} from './store';

class Users extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    isLoadedPage: PropTypes.bool.isRequired,
    loadPageData: PropTypes.func.isRequired,
    setActiveMenuItem: PropTypes.func.isRequired,
    setTitle: PropTypes.func.isRequired,
    onAddClick: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onSearchSubmit: PropTypes.func.isRequired,
    onView: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.setTitle(this.props.intl.formatMessage(pageTitles.users));
    this.props.setActiveMenuItem('users');
    this.props.loadPageData();
  }

  render() {
    return this.props.isLoadedPage ? (
      <UsersPage
        {...this.props}
      />
    ) : null;
  }
}

const mapDispatchToProps = {
  setTitle,
  setActiveMenuItem,
  onAddClick,
  onSearchSubmit,
  onDelete,
  onEdit,
  onView,
  loadPageData,
  onChangeSort,
  onChangePage,
  onChangeRowsPerPage,
};

const mapStateToProps = (state) => ({
  ...state.Users,
  ...state.Global.pagingData,
  loggedUserId: state.Global.userData.id,
  totalItemsCount: state.Users.totalItemsCount,
});


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Users));
